import {
  HMRC_URL_AUTH,
  HMRC_URL_AUTH_SUCCESS,
  HMRC_URL_AUTH_FAILURE,
  HMRC_GENERATE_ACCESS_TOKEN,
  HMRC_GENERATE_ACCESS_TOKEN_SUCCESS,
  HMRC_GENERATE_ACCESS_TOKEN_FAILURE,
} from "./actionType";

//HMRC_URL_AUTH
export const hmrcUrlAuth = () => ({
  type: HMRC_URL_AUTH,
});
export const hmrcUrlAuthSuccess = (data) => ({
  type: HMRC_URL_AUTH_SUCCESS,
  payload: data,
});
export const hmrcUrlAuthFailure = (error) => ({
  type: HMRC_URL_AUTH_FAILURE,
  payload: error,
});
//HMRC_GENERATE_ACCESS_TOKEN
export const hmrcGenerateAccessToken = (payload) => ({
  type: HMRC_GENERATE_ACCESS_TOKEN,
  payload,
});
export const hmrcGenerateAccessTokenSuccess = (data) => ({
  type: HMRC_GENERATE_ACCESS_TOKEN_SUCCESS,
  payload: data,
});
export const hmrcGenerateAccessTokenFailure = (error) => ({
  type: HMRC_GENERATE_ACCESS_TOKEN_FAILURE,
  payload: error,
});
